import { render } from "./Explain.vue?vue&type=template&id=4b6c02c2&scoped=true&ts=true"
import script from "./Explain.vue?vue&type=script&lang=ts"
export * from "./Explain.vue?vue&type=script&lang=ts"

import "./Explain.vue?vue&type=style&index=0&id=4b6c02c2&lang=scss&scoped=true"

import exportComponent from "/var/www/html/drupal/modules/custom/nvschade_calculator/assets/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6c02c2"]])

export default __exports__